// extracted by mini-css-extract-plugin
export default {"root":"ActivityCard_root__OHRHn","label":"ActivityCard_label__RfEK6 h3","listing":"ActivityCard_listing__f0a69 h3","iconWrapper":"ActivityCard_iconWrapper__86rC4"};